module.exports = __webpack_public_path__ + "img/kefu.4736b54f.jpg";